import { ca } from '@cian/analytics';

import { IJsonQuery } from '../../../../packages/api-models/common/json_query';

interface ITrackEmptyListingShowArgs {
  queryString: string;
  jsonQuery: IJsonQuery | null;
}

// Трекинг показа пустого листинга на десктопе
export const trackEmptyListingShow = ({ queryString, jsonQuery }: ITrackEmptyListingShowArgs) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'informer',
    action: 'show',
    label: 'empty_listing',
    page: { pageType: 'ListingHybrid', siteType: 'desktop', queryString },
    sc: jsonQuery,
  });
};
